/* eslint-disable @typescript-eslint/naming-convention */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewEncapsulation, Renderer2, ElementRef } from '@angular/core';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { LineItemListService } from './line-item-list.service';
import { ZuperDialogService } from '@zuper/components/zuper-dialog';
import { SerialNumbersDialogComponent } from 'app/modules/products/serial-numbers-dialog/serial-numbers-dialog.component';
import { LocalStorageService } from 'app/core/services/localstorage.service';
import { bundlePricingLevel } from 'app/modules/products/products.types';
import _ from 'lodash';
@Component({
  selector: 'app-line-item-list',
  templateUrl: './line-item-list.component.html',
  styleUrls: ['./line-item-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy?.OnPush,
})
export class LineItemListComponent implements OnInit, OnChanges {

  @Input() lineitemData: any = {};
  @Input() lineItemColumns: Array<string>;
  @Input() taxExempt: boolean;
  @Input() module: string = '';
  @Input() type: string = '';
  @Input() currentTransactionType: string = '';
  @Input() isTaxable: boolean;
  @Input() isHideViewDetails: boolean = false;
  @Input() isDetailsPage: boolean;
  @Input() isTaxExempt: boolean;
  @Input() isAvalaraEnabled: boolean;
  @Input() showCustomTaxWithAvalara: boolean;
  @Input() showLineItemsTableStyle: boolean;
  @Input() showCompanyCurrency: boolean;
  @Input() moduleElementId: string = '';
  @Input() showScheduleJobButton: boolean = false;
  @Input() showCreatePPMButton: boolean = false;
  @Input() extraClass: string = '';
  @Input() checkAllLineItems: boolean = false;
  @Input() showRowLevelActions: boolean = true;
  @Output() productEventEmitted = new EventEmitter<any>();
  @Output() productOrderChange = new EventEmitter<any>();

  products: any;
  companyConfig: any;
  company: any;
  supportedModules: string[] = ['INVOICE', 'ESTIMATES', 'PROPOSALS_FORM', 'PROPOSALS_PICKER','SERVICE_CONTRACTS', 'JOB'];

  columnsConfig = [];
  idColumnPresent: boolean = false;
  indexColumnPresent: boolean = false;
  showPrice: boolean = false;
  bundlePricingLevel: any = bundlePricingLevel;
  isTotalRecordSelected: boolean = false;
  selectedRecordsLocal: any[];
  mockColumnsConfig: any[];
  /**
   * Specifies the formatting for numeric values, particularly for currency.
   * The format `1.0-` ensures that there is always at least one digit before the decimal point,
   * and the number of digits after the decimal point is determined dynamically based on the
   * currency's decimal precision, which is retrieved from the utility service.
   */
  digitsInfo: string = `1.0-${this.utilityService.getCurrencyDecimal()}`;


  constructor(
    public utilityService: UtilityService,
    public lineItemListService: LineItemListService,
    private changeDetectorRef: ChangeDetectorRef,
    private zuperDialogService: ZuperDialogService,
    private _localStorageService: LocalStorageService,
    private renderer: Renderer2,
    private eleRef: ElementRef
  ) {}

  ngOnInit(): void {
    this.companyConfig = this._localStorageService.getLocalStorage('company_configuration_data');
    this.company = this._localStorageService.getLocalStorage('company');
    this.showPrice = this.utilityService.hasPermission('product.show_selling_price') ?? false;
    this.changeDetectorRef.detectChanges();
    this.initializeColumnsConfig();
  }

  handleItemdrop(event: CdkDragDrop<unknown>): void {
    moveItemInArray(this.products, event.previousIndex, event.currentIndex);
    this.products?.forEach((element, index) => {
      element.index = index + 1;
    });
    this.products = [...this.products];
    this.productOrderChange.emit({products:this.products});
    this.changeDetectorRef.detectChanges();
  }

  onDragStart(item: any): void{
    if(item?.expanded){
      item.expanded = false;
      this.changeDetectorRef.detectChanges();
    }
    const panelContainer = document.querySelector('.line-item-list-container');
    this.renderer.addClass(panelContainer, 'field-dragging');
  }

  onDragEnd(): void {
    const panelContainer = document.querySelector('.line-item-list-container');
    this.renderer.removeClass(panelContainer, 'field-dragging');
  }

  performPartsAction(action: string, product: any, index?: number, type?: string): void {
    this.productEventEmitted.emit({ action, product, index, type });
  }


  toggleRow(item: any): void {
    item.expanded = !item.expanded;
    this.changeDetectorRef.detectChanges();
  }

  getLocationName(product: any, type: 'BUNDLE'): string {
    const locationAvailability = type === 'BUNDLE' ? product?.product?.location_availability :  product?.product_ref_id?.location_availability ?? product?.location_availability;
    if(locationAvailability?.length){
      if(type !== 'BUNDLE'){

      }
      const selectedLocation = locationAvailability?.find((location: any) => location?.location?.location_uid === product?.location_uid);
      return selectedLocation?.location?.location_name || '---';
    }else if(product?.location_name){
      return product?.location_name ?? '---';
    }else{
      return '---';
    }
  }

  initializeColumnsConfig(): void {
    if (this.lineItemColumns && Array.isArray(this.lineItemColumns)) {
      this.columnsConfig = this.lineItemListService.productColumnsConfigs.filter(column => this.lineItemColumns.includes(column.key));
    }

    this.idColumnPresent = this.columnsConfig.some(column => column.key === 'id');
    this.indexColumnPresent = this.columnsConfig.some(column => column.key === 'index');

    if ((this.module === 'INVOICE' || this.module === 'ESTIMATES' || this.module === 'PROPOSALS_FORM' || this.module === 'PROPOSALS_PICKER') && !this.isDetailsPage) {
      this.columnsConfig.forEach((column) => {
        if (column.key === 'id') {
          column.headerClass = 'w-3/12';
        }
        else if (column.key === 'index') {
          column.headerClass = 'w-2/12';
        }
        else if (column.key === 'product') {
          column.headerClass = 'w-10/12';
        }
        else if(column.key === 'specification') {
          column.headerClass = 'w-3/12';
        }
        else if(column.key === 'price') {
          column.headerClass = 'w-5/12';
        }
        else if(column.key === 'total') {
          column.headerClass = 'w-3/12';
        }
        else if(column.key === 'brand' && this.module === 'PROPOSALS_PICKER') {
          column.headerClass = 'w-3/12';
        }
      });
    }
    else if (this.module === 'ASSETS') {
        this.columnsConfig.forEach((column) => {
          if (column.key === 'product') {
            column.headerClass = 'w-10/12';
            column.label = 'text.part_name';
          }
          else if (column.key === 'serial_no') {
            column.headerClass = 'w-3/12';
          }
        });
    }
    else if (this.module === 'PRODUCT_GROUP') {
        this.columnsConfig.forEach((column) => {
          if (column.key === 'specification') {
            column.headerClass = 'w-4/12';
          }
          else if (column.key === 'brand') {
            column.headerClass = 'w-4/12';
          }
          else if (column.key === 'type') {
            column.headerClass = 'w-4/12';
          }
        });
    }

    if (this.isDetailsPage) {
      this.columnsConfig.forEach((column) => {
        if (column.key === 'product' || column.key === 'line_item') {
          if(['ESTIMATES', 'PRESENT_PROPOSALS_FORM', 'APPROVE_LINEITEM_FORM'].includes(this.module)){
            column.headerClass = 'w-7/12';
          }else{
            column.headerClass = 'w-6/12';
          }
        }
        else if (column.key === 'index' && this.module === 'INVOICE') {
          column.headerClass = 'w-2/12';
        }
        else if (column.key === 'total' && this.module === 'SERVICE_CONTRACTS') {
          column.headerClass = 'w-4/12';
        }
        else if (column.key === 'amount' && this.module === 'SERVICE_CONTRACTS') {
          column.headerClass = 'w-4/12';
        }
        else if (column.key === 'discount' && this.module === 'SERVICE_CONTRACTS') {
          column.headerClass = 'w-3/12';
        }
        else if (column.key === 'location') {
          column.headerClass = 'w-3/12';
        }
        else if(column.key === 'price') {
          if(['PRESENT_PROPOSALS_FORM', 'APPROVE_LINEITEM_FORM'].includes(this.module)){
            column.headerClass = 'w-5/12';
          }else{
            column.headerClass = 'w-4/12';
          }
          column.label = this.utilityService.getLocaleValue('text.price')+'('+ this.company?.company_currency +')';
        }
        else if (column.key === 'total' && this.showCompanyCurrency) {
          column.headerClass = 'w-4/12';
          column.label = this.utilityService.getLocaleValue('text.total')+'('+ this.company?.company_currency +')';
        }
        else if(column.key === 'quantity' && ['PRESENT_PROPOSALS_FORM', 'APPROVE_LINEITEM_FORM'].includes(this.module)) {
          column.headerClass = 'w-3/12';
        }
      });
    }
    this.mockColumnsConfig = _.cloneDeep(this.columnsConfig);
    this.changeDetectorRef.detectChanges();
  }

  openSerialNumberDialog(product): void{
    const lineItem = product?.location_availability ? product : {...product,...product?.product_ref_id, serial_nos: product?.serial_nos};
    if(lineItem.name && !lineItem.product_name){
      lineItem['product_name']= lineItem.name;
      this.changeDetectorRef.detectChanges();
    }
    const serialNumberDialog: any = this.zuperDialogService.openCustom(SerialNumbersDialogComponent,
      {
        data: {
          productName: lineItem.product_name,
          locationData: lineItem
        },
        disableClose: true,
        extraClass: 'serial-number-dialog',
        hasBackdrop: true,
        dialogTitle: `${this.utilityService.getLocaleValue('product.details.serial_number_table.title')} ${lineItem.product_name}`
      });
  }

  isDisableDrag(): boolean {
    return this.columnsConfig.some(column => column.key === 'index') ? false : true;
  }

  setLineClamp(flag, index): void {
    const element = this.eleRef.nativeElement.querySelector('.description-' + index);

    if (element) {
      if (flag) {
        this.renderer.addClass(this.eleRef.nativeElement.querySelector('.description-' + index), 'line-clamp clamped-text');
      }
      else {
        this.renderer.removeClass(this.eleRef.nativeElement.querySelector('.description-' + index), 'line-clamp clamped-text');
      }
    }

  }

  updateProductsWithTaxInfo(): void {
    const data = [];
    let count = 1;
    this.products?.forEach((product) => {
      // Check if associated product has a custom tax
      const hasCustomTax = (product.associated_products ?? []).some((associatedProduct) => {
        const tax = associatedProduct?.tax;
        return (product.product_type === this.bundlePricingLevel.BUNDLE && product.pricing_level === this.bundlePricingLevel.ROLLUP)
                && tax?.tax_exempt === false && tax?.tax_rate > 0;
      });

      // Set the has_rollup_custom_tax property
      product.has_rollup_custom_tax = hasCustomTax;

      // Prepare line item data
      if ((['PART', 'PARTS', 'SERVICE', 'PRODUCT', 'BUNDLE'].includes(product?.product_type) && product?.line_item_type !== 'HEADER') || (product?.line_item_type === 'ITEM' && this.indexColumnPresent)) {
        data.push({
          index: count,
          ...product,
          product_name: product?.product_name || product?.name
        });
        count += 1;
      }else{
        data.push({
          ...product,
          product_name: product?.product_name || product?.name,
          line_item_type: product?.line_item_type
        });
      }
    });

    this.products = data;  // Set processed products
    this.changeDetectorRef.detectChanges();
  }

  lineItemApproval(action: string, index?: number): void{
    const eventPayload: any = { action };
    if (index !== undefined) {
      eventPayload.index = index;
    }
    this.productEventEmitted.emit(eventPayload);
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle(currentValue): void {
    this.products = this.products?.map((data: any)=>({...data,selected:  data?.line_item_type !== 'HEADER' ? currentValue : false}));
    this.isTotalRecordSelected = this.isAllSelected();
    this.hideAcionColumn(this.hasSelectedRecord);
    const eventPayload = {action: 'BULKACTION',product: this.products};
    this.productEventEmitted.emit(eventPayload);
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected(): any {
    const numSelected = this.products?.filter((data: any)=> data?.line_item_type !== 'HEADER' && data['selected'] === true)?.length;
    const numRows = this.products?.filter((data: any)=> data?.line_item_type !== 'HEADER')?.length;
    return numSelected === numRows && this.products?.filter((data: any)=> data?.line_item_type !== 'HEADER')?.length > 0;
  }

  rowlevelSelected(index: any): void{
    this.products[index].selected = !this.products[index]?.selected;
    this.isTotalRecordSelected = this.isAllSelected() === true;
    this.hideAcionColumn(this.hasSelectedRecord);
    const eventPayload = {action: 'BULKACTION',product: this.products};
    this.productEventEmitted.emit(eventPayload);
  }

  hideAcionColumn(hide: boolean): void{
      let columns = _.cloneDeep(this.mockColumnsConfig);
      columns = columns?.filter((data: any)=> {
        if(hide){
          return data?.key !== 'action';
        }else{
          return data;
        }
      });
      this.columnsConfig = columns;
  }

  get hasSelectedRecord(): boolean{
    return this.products?.findIndex((data: any)=> data?.selected === true) !== -1;
  }

  ngOnChanges(changes: SimpleChanges): void {

    if ('lineItemColumns' in changes) {
      this.initializeColumnsConfig();
    }

    if('lineitemData' in changes){
      this.products = changes.lineitemData.currentValue ?? [];
      this.isTotalRecordSelected = this.isAllSelected() === true;
      this.changeDetectorRef.detectChanges();
      this.updateProductsWithTaxInfo();
      this.hideAcionColumn(this.hasSelectedRecord);
    }
    if ('taxExempt' in changes) {
      this.taxExempt = changes.taxExempt.currentValue ?? false;
      this.changeDetectorRef.detectChanges();
    }
    if ('module' in changes) {
      this.module = changes.module.currentValue ?? false;
      this.changeDetectorRef.detectChanges();
    }
    if ('type' in changes) {
      this.type = changes.type.currentValue ?? false;
      this.changeDetectorRef.detectChanges();
    }
    if ('currentTransactionType' in changes) {
      this.currentTransactionType = changes.currentTransactionType.currentValue ?? false;
      this.changeDetectorRef.detectChanges();
    }
    if ('isTaxable' in changes) {
      this.isTaxable = changes.isTaxable.currentValue ?? false;
      this.changeDetectorRef.detectChanges();
    }
    if ('isHideViewDetails' in changes) {
      this.isHideViewDetails = changes.isHideViewDetails.currentValue ?? false;
      this.changeDetectorRef.detectChanges();
    }
    if ('isDetailsPage' in changes) {
      this.isDetailsPage = changes.isDetailsPage.currentValue ?? false;
      this.changeDetectorRef.detectChanges();
    }
    if ('isTaxExempt' in changes) {
      this.isTaxExempt = changes.isTaxExempt.currentValue ?? false;
      this.changeDetectorRef.detectChanges();
    }
    if ('showCustomTaxWithAvalara' in changes) {
      this.showCustomTaxWithAvalara = changes.showCustomTaxWithAvalara.currentValue ?? false;
      this.changeDetectorRef.detectChanges();
    }
    if ('isAvalaraEnabled' in changes) {
      this.isAvalaraEnabled = changes.isAvalaraEnabled.currentValue ?? false;
      this.changeDetectorRef.detectChanges();
    }
    if ('showLineItemsTableStyle' in changes) {
      this.showLineItemsTableStyle = changes.showLineItemsTableStyle.currentValue ?? false;
      this.changeDetectorRef.detectChanges();
    }

    if('checkAllLineItems' in changes){
      this.checkAllLineItems = changes.checkAllLineItems.currentValue ?? false;
      this.changeDetectorRef.detectChanges();
    }

    this.changeDetectorRef.markForCheck();
  }
}
